<template>
  <div class="inline-block relative">
    <div
      ref="selector"
      class="inline-block"
      :aria-describedby="uniqueId"
      @mouseover="show"
      @mouseout="hide"
      @focusin="show"
      @focusout="hide"
    >
      <slot></slot>
    </div>
    <div
      :id="uniqueId"
      ref="tooltip"
      role="tooltip"
      class="tooltip rounded bg-black text-white px-2 py-1 text-xs whitespace-no-wrap"
    >
      {{ tooltip }}
      <div
        class="popper-arrow"
        data-popper-arrow
      ></div>
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import Utils from '../_mixins/Utils';

export default {
  name: 'Tooltip',
  mixins: [Utils],
  props: {
    placement: {
      type: String,
      default: () => 'top',
    },
    tooltip: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      active: false,
      popperInstance: null,
    };
  },
  methods: {
    show() {
      const { selector, tooltip } = this.$refs;
      if (!this.popperInstance) {
        this.popperInstance = createPopper(selector, tooltip, {
          placement: this.placement,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 5],
              },
            },
          ],
        });
      }
      if (tooltip) {
        tooltip.setAttribute('data-show', '');
      }
      this.active = true;
      this.$nextTick(() => this.$forceUpdate());
    },
    hide() {
      const { tooltip } = this.$refs;
      if (tooltip) {
        tooltip.removeAttribute('data-show');
      }
      this.active = false;
      if (this.popperInstance) {
        this.popperInstance.destroy();
        this.popperInstance = null;
      }
    },
  },
  beforeDestroy() {
    if (this.popperInstance) {
      this.popperInstance.destroy();
      this.popperInstance = null;
    }
  },
};
</script>

<style>
  .tooltip {
    display: none;
  }
  .tooltip[data-show] {
    display: block;
  }
</style>
